// setDefaultShopCurrency.js
'use strict';
import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getProductData from '../selector/getProductData.js';

import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import { SHOP_CURRENCIES } from '../RemoteConfigKeys.js';

/**
 * Set default shop currency
 * @kind action
 * @param {string} {productId} - product id.
 * @return {Promise} Action promise.
 */
const setDefaultShopCurrency =
  ({ productId } = {}) =>
  async (dispatch, getState) => {
    const productCurrencies =
      getProductData(getState(), [productId], 'currencies') || [];
    const shopCurrencies =
      getRemoteConfigData(getState(), SHOP_CURRENCIES) || [];
    const currencyCodes = productCurrencies.length
      ? productCurrencies
      : shopCurrencies;
    const meCurrencyCode = getMeData(getState(), 'currency');
    const isMeCurrencyAvaliable =
      meCurrencyCode && currencyCodes.includes(meCurrencyCode);
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['shop'],
        data: {
          currency: isMeCurrencyAvaliable ? meCurrencyCode : currencyCodes[0],
        },
      },
    });
  };

export default setDefaultShopCurrency;
